import ApiInterface from "utils/ApiInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export async function deleteGuestsUsersApi(users, org_id) {
  const data = {
    users: users,
    org_id: org_id
  };
  try {
    const response = await ApiInterface.instance.deleteGuestsUsers(data, org_id);
    return response;
  } catch (error) {
    if (error) {
      console.log("Error in delete data: ", error);
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    }
  }
}
